const size = {
  w_set : '1080px'
}
const theme = {
  mobile : `(max-width : ${size.w_set})`
}
